import { SET_GOALS, ADD_GOAL, UPDATE_GOAL, DELETE_GOAL } from './actionTypes'

const initialState = { items: [] }

const items = (state = initialState, action) => {
  let items
  switch (action.type) {
    case SET_GOALS:
      return { ...state, items: action.items }
    case ADD_GOAL:
      items = state.items.concat(action.item)
      return { ...state, items }
    case UPDATE_GOAL:
      items = state.items.map(t => {
        if (t.id === action.item.id) {
          t = action.item
        }
        return t
      })
      return { ...state, items }
    case DELETE_GOAL:
      items = state.items.filter(t => t.id !== action.item.id)
      return { ...state, items }
    default:
      return state
  }
}

export default items
